import { setOptions, importLibrary } from "@googlemaps/js-api-loader"
import { MarkerClusterer, SuperClusterAlgorithm, NoopAlgorithm } from "@googlemaps/markerclusterer"

class CustomNoopAlgorithm extends NoopAlgorithm {
  calculate({ markers, map, mapCanvasProjection }) {
    return {
      clusters: this.cluster({ markers, map, mapCanvasProjection }),
      changed: true
    }
  }
}

let algorithm = function() {
  let noop = document.getElementById("disable_clustering").checked
  return noop ? new CustomNoopAlgorithm() : new SuperClusterAlgorithm({ radius: 60 })
}

let clusterer

$(document).on("change", "#disable_clustering", function() {
  clusterer.algorithm = algorithm()
  clusterer.render()

  document.cookie = `disable_clustering=${this.checked}; Max-Age=31536000; Path=/`
})

$(async function() {
  const mapEl = document.getElementById("map")
  if (mapEl) {
    setOptions({ key: mapEl.getAttribute("data-api-key"), v: "quarterly" })

    const { Map, InfoWindow } = await importLibrary("maps")
    const { AdvancedMarkerElement } = await importLibrary("marker")
    const { LatLngBounds } = await importLibrary("core")

    const json = JSON.parse(document.getElementById("mapData").innerText)
    const map = new Map(mapEl, { mapId: "ministers-map" })
    const bounds = new LatLngBounds()
    const parser = new DOMParser()

    const markers = json.map(({ position, icon, infowindow }) => {
      const content = parser.parseFromString(icon, "image/svg+xml").documentElement
      const marker = new AdvancedMarkerElement({ position, content, map })

      marker.addListener("gmp-click", () => {
        new InfoWindow({ content: infowindow }).open({ anchor: marker, map, shouldFocus: false })
      })

      bounds.extend(position)
      return marker
    })

    map.fitBounds(bounds)
    clusterer = new MarkerClusterer({ map, markers, algorithm: algorithm() })
  }
})
